import { SecondHeading } from '@shared';
import styled from 'styled-components';

export const AuthHeading = styled(SecondHeading).attrs({
  navy: true,
  textAlign: 'center',
})``;
